import AbstractEntryCommand from "./AbstractEntryCommand.js";
import getNamedCommandHeading from "../getNamedCommandHeading.js";
import selection from "../selection.js";

/**
 * `editEntryPermissionsCommand` is the command used to edit the permission
 * of an entry.
 * `editEntryPermissionsCommand` is valid if the selection contains exactly
 * one entry, and this this entry can be edited.
 *
 */
export default class EditEntryPermissionsCommand extends AbstractEntryCommand {
	accept(aVisitor) {
		return aVisitor.visitEditEntryPermissionsCommand(this);
	}

	requireRefresh() {
		return true;
	}

	priority() {
		return 300;
	}

	heading() {
		return getNamedCommandHeading("Actions");
	}

	_performOnService(callback) {
		this._documentService.executeEditPermissionsCommand(this, callback);
	}

	static isApplicable() {
		return (
			selection.isSingleSelection() &&
			selection.firstEntry().canPermissionsBeEdited()
		);
	}
}
